import { useEffect, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { TextInput } from "../../components/shared/Inputs/TextInput";
import { ButtonInput } from "../../components/shared/Inputs/ButtonInput";
import { useForm } from "react-hook-form";

import useSingleLead from "../../data/useSingleLead";
import openInNewTab from "../../utils/openInNewTab";
import LoadingWheel from "../../components/shared/LoadingWheel";

export default function Search() {
  const { getLeadByVrm } = useSingleLead(null);
  const { setInfo } = usePageNameContext();
  const { register, handleSubmit, reset, watch, setValue } = useForm();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  
  useEffect(() => {
    setInfo({
      name: "Find a Lead",
      desc: "Search for a lead to view details",
    });
  }, []);


  const onSubmit = (data: any) => {
    setLoading(true);
    getLeadByVrm.mutate(data.vehicleRegistration, {
      onSuccess: (data) => {
        setLoading(false);
        if (data.success) {
          window.location.href = `/leads/${data.data.id}`;
        } else {
          setError("No lead found with that vehicle registration");
        }
      },
      onError: (error: any) => {
        setLoading(false);
        console.error("Error fetching lead by VRM:", error);
        setError("An error occurred while searching for the lead. Please try again.");
      },
    });
  };

  if (loading) return <LoadingWheel />;

  return (
    <>
      <form className="mt-6" onSubmit={handleSubmit(onSubmit)}>
        <TextInput
          label={"Vehicle Registration"}
          placeholder={"Enter vehicle registration"}
          registerName={"vehicleRegistration"}
          register={register}
        />
        <ButtonInput 
          isSubmit={true} 
          label={"Search"} 
          classes="mt-4" 
        />
        {error && <p className="text-red-500 mt-2">{error}</p>}
      </form>
    </>
  )
}